import { graphql } from 'react-relay';

export const aboHeaderFragment = graphql`
    fragment AboHeader_header on SubscriptionTable {
        tableheader {
            col
            label
        }
    }
`;
